module.exports = __webpack_public_path__ + "img/标准直通车.bbe02923.png";